import { SvgIcon, SvgIconProps } from "@mui/material";

export const BackButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "17", height: "14", fill: "none" }}
      width="17"
      height="14"
      viewBox="0 0 17 14"
      fill="none"
    >
      <path d="M16 7H2M2 7L8 1M2 7L8 13" stroke="#111111" strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
};

export const CandidateStatusDropDownIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "17", height: "14", fill: "none" }}
      width="17"
      height="14"
      viewBox="0 0 17 14"
      fill="none"
    >
      <path d="M5 7.5L10 12.5L15 7.5" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
};

export const FitScoreIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M9.5 3H14.5V5.5C13 6.5 11 6.5 9.5 5.5V3Z"
        stroke="#00B809"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 5.5L17.1026 6.36754C18.2971 6.76568 19.2343 7.70295 19.6325 8.89737L20.7947 12.3842C20.9307 12.7921 21 13.2192 21 13.6491V19H17.5M17.5 19V14L16.5 11M17.5 19V21H6.5V19M9.5 5.5L6.89737 6.36754C5.70295 6.76568 4.76568 7.70295 4.36754 8.89737L3.20527 12.3842C3.06931 12.7921 3 13.2192 3 13.6491V19H6.5M6.5 19V14L7.5 11"
        stroke="#00B809"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 16.5L9 15L10.5 16.5L12 15L13.5 16.5L15 15L17.5 16.5"
        stroke="#00B809"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const FitScoreInfoIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <circle cx="10" cy="10" r="8" fill="#AFAFAF" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3047 7.24219C11.4297 7.02344 11.5 6.76953 11.5 6.5C11.5 5.67188 10.8281 5 10 5C9.17188 5 8.5 5.67188 8.5 6.5C8.5 7.32812 9.17188 8 10 8C10.5586 8 11.0469 7.69531 11.3047 7.24219ZM9 9H9.5H10.5C11.0527 9 11.5 9.44727 11.5 10V11V15C11.5 15.5527 11.0527 16 10.5 16C9.94727 16 9.5 15.5527 9.5 15V11.75C9.5 11.3359 9.16406 11 8.75 11C8.33594 11 8 10.6641 8 10.25V10C8 9.64844 8.18164 9.33789 8.45508 9.16016C8.61133 9.05859 8.79883 9 9 9Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const HeightIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "28", height: "28", fill: "none" }}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <rect width="28" height="28" rx="14" fill="#008B07" />
      <path
        d="M18.1783 6.04014C17.9026 5.76445 17.4537 5.76445 17.178 6.04014L16.5383 6.6799L17.7188 7.86042C17.8566 7.99826 17.8566 8.22093 17.7188 8.35879C17.6481 8.42948 17.5597 8.46129 17.4679 8.46129C17.376 8.46129 17.2876 8.42595 17.2169 8.35879L16.0364 7.17827L14.0005 9.21415L15.637 10.8507C15.7748 10.9885 15.7748 11.2112 15.637 11.349C15.5663 11.4197 15.4779 11.4515 15.386 11.4515C15.2941 11.4515 15.2058 11.4162 15.1351 11.349L13.4986 9.71253L11.4627 11.7484L12.6432 12.9289C12.7811 13.0668 12.7811 13.2894 12.6432 13.4273C12.5725 13.498 12.4842 13.5298 12.3923 13.5298C12.3004 13.5298 12.212 13.4945 12.1413 13.4273L10.9679 12.2503L8.93201 14.2862L10.5685 15.9227C10.7063 16.0605 10.7063 16.2832 10.5685 16.4211C10.4978 16.4918 10.4094 16.5236 10.3176 16.5236C10.2257 16.5236 10.1373 16.4882 10.0666 16.4211L8.4301 14.7846L6.04075 17.1739C5.76506 17.4496 5.76506 17.8985 6.04075 18.1742L8.65984 20.7933C8.93553 21.069 9.38442 21.069 9.6601 20.7933L20.7974 9.65601C21.073 9.38031 21.073 8.93142 20.7974 8.65574L18.1783 6.04014ZM8.91083 19.0436C8.84014 19.1143 8.75177 19.1461 8.65988 19.1461C8.56798 19.1461 8.47962 19.1108 8.40893 19.0436L7.79037 18.4251C7.65253 18.2872 7.65253 18.0646 7.79037 17.9267C7.92822 17.7889 8.15089 17.7889 8.28874 17.9267L8.9073 18.5453C9.04868 18.6831 9.04868 18.9058 8.91083 19.0436H8.91083Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const StrongFootIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "29", height: "28", fill: "none" }}
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
    >
      <rect x="0.25" width="28" height="28" rx="14" fill="#008B07" />
      <path
        d="M19.3897 19.5698C19.4232 19.5837 19.4583 19.5932 19.4941 19.5978C19.7301 19.6606 19.9756 19.536 20.0645 19.3085C20.1535 19.0812 20.0574 18.8231 19.8417 18.7091L6.72481 11.7672C6.97488 11.2974 7.27798 10.7323 7.67754 10.0664C8.85907 8.05919 10.1415 7.84611 10.2833 7.82691C10.5261 7.79667 10.7526 7.95369 10.8096 8.19155C10.8645 8.42304 10.9063 8.65748 10.9345 8.8937C10.9591 9.02261 11.0312 9.13783 11.1365 9.21618C11.1861 9.24446 12.9763 10.2436 13.767 10.6044C14.1362 10.7754 15.1914 10.2877 15.8058 9.86837C15.9134 9.79526 16.0459 9.76878 16.1734 9.79525C16.3007 9.82123 16.412 9.89788 16.4819 10.0073L17.5784 11.7129L15.494 12.7301L15.4938 12.73C15.2561 12.8469 15.1581 13.1342 15.2745 13.3721C15.3354 13.4973 15.4475 13.5897 15.5818 13.6259C15.6935 13.6556 15.8121 13.6444 15.916 13.5938L18.1031 12.5269L18.6061 13.3029L17.5413 13.8079C17.3606 13.8943 17.2525 14.0836 17.2698 14.2829C17.2873 14.4824 17.4265 14.6501 17.6194 14.7036C17.73 14.7335 17.8475 14.7225 17.9506 14.6732L19.13 14.1119C19.3395 14.4339 19.5252 14.7148 19.6591 14.9198C20.0471 15.4486 20.5058 15.9219 21.0221 16.3263C22.0468 17.2048 23.2116 18.2003 22.4478 20.1605C22.3055 20.5882 21.9953 20.9394 21.5882 21.1331C21.2178 21.2841 20.8074 21.3071 20.4225 21.1985C20.3697 21.1882 20.3179 21.1743 20.267 21.1569L20.216 21.1432L7.29092 14.2924C6.88128 14.0712 6.56746 13.7066 6.40963 13.2684C6.34942 13.0724 6.33438 12.8653 6.36576 12.6627L19.3897 19.5698Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const WeightIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "29", height: "28", fill: "none" }}
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
    >
      <rect x="0.5" width="28" height="28" rx="14" fill="#008B07" />
      <path
        d="M18.8811 9.81263L14.8267 6.13904C14.3562 5.7134 13.5723 5.73592 13.1243 6.18388L9.45075 9.83512C8.17387 11.112 7.45715 12.8367 7.50199 14.6511C7.52433 16.4655 8.26354 18.168 9.5851 19.4223C10.8171 20.5871 12.4523 21.2143 14.1771 21.2143C15.9019 21.2143 17.5371 20.5648 18.7691 19.4C20.0907 18.1456 20.8299 16.4431 20.8522 14.6288C20.8971 12.8368 20.2025 11.1119 18.881 9.8128L18.8811 9.81263ZM17.6939 18.2798C16.7531 19.1757 15.4987 19.6462 14.177 19.6462C12.8555 19.6462 11.6011 19.1534 10.6601 18.2798C9.65219 17.3167 9.06966 16.0175 9.04734 14.6286C9.025 13.2398 9.56251 11.9181 10.5481 10.9327L13.9753 7.50548L17.7833 10.9327C18.7689 11.9183 19.3064 13.2399 19.2841 14.6286C19.2844 16.0175 18.7244 17.3167 17.6939 18.2798H17.6939Z"
        fill="white"
      />
      <path
        d="M17.1566 11.5822L14.3342 9.02856C14.2222 8.91653 14.043 9.00622 14.043 9.16294V18.6381C14.043 18.7277 14.1325 18.8173 14.2222 18.8173C14.6478 18.8173 15.0734 18.7502 15.4766 18.5933C18.6799 17.4061 19.2399 13.6653 17.1566 11.5821L17.1566 11.5822Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const AgeIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "29", height: "28", fill: "none" }}
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
    >
      <rect x="0.75" width="28" height="28" rx="14" fill="#008B07" />
      <path
        d="M20.49 20.0187H9.01002C8.67586 20.0187 8.3554 19.886 8.11908 19.6496C7.88275 19.4134 7.75 19.0928 7.75 18.7587V10.335C7.75 10.0008 7.88274 9.68028 8.11908 9.44403C8.3554 9.20771 8.67586 9.07495 9.01002 9.07495H20.49C20.8241 9.07495 21.1446 9.20769 21.3809 9.44403C21.6172 9.68028 21.75 10.0008 21.75 10.335V18.7602C21.7496 19.0941 21.6167 19.4142 21.3804 19.6502C21.1442 19.8862 20.8239 20.0187 20.49 20.0187Z"
        fill="white"
      />
      <path
        d="M9.95743 10.2732C9.86459 10.2732 9.77556 10.2363 9.70992 10.1707C9.64436 10.1051 9.60742 10.0161 9.60742 9.92323V8.22504C9.60742 8.10001 9.67417 7.98447 9.78242 7.92195C9.89076 7.85935 10.0242 7.85935 10.1324 7.92195C10.2408 7.98446 10.3074 8.1 10.3074 8.22504V9.92323C10.3074 10.0161 10.2706 10.1051 10.2049 10.1707C10.1393 10.2363 10.0503 10.2732 9.95744 10.2732H9.95743Z"
        fill="white"
      />
      <path
        d="M19.2953 10.2732C19.2025 10.2732 19.1135 10.2363 19.0478 10.1707C18.9822 10.1051 18.9453 10.0161 18.9453 9.92323V8.22504C18.9453 8.10001 19.0121 7.98447 19.1203 7.92195C19.2286 7.85935 19.3621 7.85935 19.4703 7.92195C19.5786 7.98446 19.6453 8.1 19.6453 8.22504V9.92323C19.6453 10.0161 19.6085 10.1051 19.5428 10.1707C19.4772 10.2363 19.3882 10.2732 19.2953 10.2732H19.2953Z"
        fill="white"
      />
      <path
        d="M22.2295 12.25H7.27054C7.12926 12.25 6.9986 12.1667 6.92798 12.0312C6.85734 11.8959 6.85734 11.7291 6.92798 11.5937C6.99862 11.4583 7.12927 11.375 7.27054 11.375H22.2295C22.3707 11.375 22.5014 11.4583 22.572 11.5937C22.6427 11.7291 22.6427 11.8959 22.572 12.0312C22.5014 12.1667 22.3707 12.25 22.2295 12.25Z"
        fill="#008B07"
      />
    </SvgIcon>
  );
};

export const ExperienceIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "28", height: "28", fill: "none" }}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <rect width="28" height="28" rx="14" fill="#008B07" />
      <path
        d="M11 20.75V10.25C11 9.55252 11 9.20378 11.0767 8.91766C11.2847 8.1412 11.8912 7.53472 12.6677 7.32667C12.9538 7.25 13.3025 7.25 14 7.25C14.6975 7.25 15.0462 7.25 15.3323 7.32667C16.1088 7.53472 16.7153 8.1412 16.9233 8.91766C17 9.20378 17 9.55252 17 10.25C17 10.25 17 21.125 17 15.125M17 18.125C17 14.2525 17 20.75 17 20.75M10.1 20.75H17.9C19.1601 20.75 19.7902 20.75 20.2715 20.5048C20.6948 20.289 21.039 19.9448 21.2548 19.5215C21.5 19.0402 21.5 18.4101 21.5 17.15V13.85C21.5 12.5899 21.5 11.9598 21.2548 11.4785C21.039 11.0552 20.6948 10.711 20.2715 10.4952C19.7902 10.25 19.1601 10.25 17.9 10.25H10.1C8.83988 10.25 8.20982 10.25 7.72852 10.4952C7.30516 10.711 6.96095 11.0552 6.74524 11.4785C6.5 11.9598 6.5 12.5899 6.5 13.85V17.15C6.5 18.4101 6.5 19.0402 6.74524 19.5215C6.96095 19.9448 7.30516 20.289 7.72852 20.5048C8.20982 20.75 8.83988 20.75 10.1 20.75Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const LanguagesIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "29", height: "28", fill: "none" }}
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
    >
      <rect x="0.5" width="28" height="28" rx="14" fill="#008B07" />
      <path
        d="M7 14H22M7 14C7 18.1421 10.3579 21.5 14.5 21.5M7 14C7 9.85786 10.3579 6.5 14.5 6.5M22 14C22 18.1421 18.6421 21.5 14.5 21.5M22 14C22 9.85786 18.6421 6.5 14.5 6.5M14.5 6.5C16.376 8.55376 17.4421 11.219 17.5 14C17.4421 16.781 16.376 19.4462 14.5 21.5M14.5 6.5C12.624 8.55376 11.5579 11.219 11.5 14C11.5579 16.781 12.624 19.4462 14.5 21.5"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const FormationsIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "29", height: "28", fill: "none" }}
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
    >
      <rect x="0.25" width="28" height="28" rx="14" fill="#008B07" />
      <path
        d="M20.0256 8.22498C16.8366 5.03601 11.6648 5.03601 8.47571 8.22498C5.28674 11.4139 5.28674 16.5857 8.47571 19.7749C11.6647 22.9638 16.8364 22.9638 20.0256 19.7749C23.2145 16.5859 23.2145 11.4141 20.0256 8.22498ZM14.2506 15.4155C13.4669 15.4155 12.835 14.7799 12.835 13.9999C12.835 13.2198 13.4706 12.5842 14.2506 12.5842C15.0307 12.5842 15.6663 13.2198 15.6663 13.9999C15.6663 14.7799 15.0343 15.4155 14.2506 15.4155Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const TeamsCoachedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "29", height: "28", fill: "none" }}
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
    >
      <rect x="0.5" width="28" height="28" rx="14" fill="#008B07" />
      <path
        d="M21.3662 14.2056C21.3662 17.9372 18.3425 20.9609 14.6206 20.9609C10.8889 20.9609 7.86523 17.9372 7.86523 14.2056C7.86523 10.4739 10.8889 7.45996 14.6206 7.45996C18.3425 7.45996 21.3662 10.4739 21.3662 14.2056V14.2056Z"
        stroke="white"
        strokeLinejoin="round"
      />
      <path
        d="M10.5624 14.2056C10.5624 15.6982 9.35691 16.9039 7.86413 16.9039C6.37174 16.9039 5.16602 15.6982 5.16602 14.2056C5.16602 12.713 6.37154 11.5073 7.86432 11.5073C9.35691 11.5073 10.5626 12.7129 10.5626 14.2056H10.5624Z"
        fill="white"
      />
      <path
        d="M21.0978 8.53157C21.0978 10.0242 19.8922 11.2395 18.3995 11.2395C16.9069 11.2395 15.7012 10.0244 15.7012 8.53157C15.7012 7.04838 16.9069 5.83325 18.3995 5.83325C19.892 5.83325 21.0978 7.04838 21.0978 8.53157Z"
        fill="white"
      />
      <path
        d="M21.0978 19.8797C21.0978 21.3723 19.8922 22.5781 18.3995 22.5781C16.9069 22.5781 15.7012 21.3725 15.7012 19.8797C15.7012 18.3871 16.9067 17.1814 18.3995 17.1814C19.892 17.1814 21.0978 18.3869 21.0978 19.8797Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const CountriesCoachedInIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "29", height: "28", fill: "none" }}
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
    >
      <rect x="0.75" width="28" height="28" rx="14" fill="#008B07" />
      <path
        d="M21.75 12.8333C21.75 8.95392 18.5417 5.83325 14.75 5.83325C10.8707 5.83325 7.75 8.95409 7.75 12.8333V13.1249C7.75 13.1541 7.86667 14.1749 7.98333 14.6124C8.8 18.0251 11.5707 20.6208 14.75 23.0418C17.9292 20.6209 20.7 18.0251 21.5167 14.6124C21.6333 14.1749 21.75 13.1833 21.75 13.1249V12.8333ZM14.75 15.7499C13.1458 15.7499 11.8333 14.4374 11.8333 12.8333C11.8333 11.2291 13.1458 9.91659 14.75 9.91659C16.3542 9.91659 17.6667 11.2291 17.6667 12.8333C17.6667 14.4374 16.3542 15.7499 14.75 15.7499Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const RepresentedClubsIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "29", height: "28", fill: "none" }}
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
    >
      <rect x="0.25" width="28" height="28" rx="14" fill="#008B07" />
      <path
        d="M21.522 9.38803L14.4819 5.88741C14.3376 5.81552 14.1712 5.81552 14.0269 5.88741L6.98679 9.38803C6.878 9.44038 6.7883 9.52998 6.73149 9.64276C6.67468 9.75567 6.654 9.88551 6.67274 10.0124L7.75584 17.0136C7.78001 17.1637 7.85774 17.2977 7.97246 17.387L13.9295 22.0544C14.0222 22.1275 14.1341 22.1668 14.249 22.1668C14.3638 22.1668 14.4757 22.1275 14.5685 22.0544L20.5255 17.387C20.6402 17.2977 20.7179 17.1637 20.7421 17.0136L21.8252 10.0124C21.8448 9.88694 21.8257 9.75801 21.7709 9.64536C21.7162 9.53258 21.6288 9.44233 21.522 9.38802L21.522 9.38803ZM20.0219 11.045L19.2528 16.0215V16.0216C19.2286 16.1718 19.1509 16.3058 19.0362 16.395L14.5739 19.8956C14.4811 19.9687 14.3692 20.008 14.2544 20.008C14.1395 20.008 14.0276 19.9687 13.9349 19.8956L9.47253 16.395C9.35781 16.3058 9.28008 16.1718 9.25591 16.0216L8.48685 11.0447C8.46775 10.9187 8.48757 10.7892 8.54342 10.6766C8.59915 10.5638 8.68775 10.4738 8.79558 10.4205L14.0269 7.81839C14.1713 7.7465 14.3376 7.7465 14.4819 7.81839L19.7133 10.4205H19.7132C19.821 10.4738 19.9096 10.5638 19.9653 10.6766C20.0212 10.7892 20.041 10.9187 20.0219 11.0447L20.0219 11.045Z"
        fill="white"
      />
      <path
        d="M9.625 11.2899L10.291 15.5957L14.2552 18.6996L18.2193 15.5957L18.8854 11.2899L14.2553 8.99121L9.625 11.2899Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const TotalScoutedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "29", height: "28", fill: "none" }}
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
    >
      <rect x="0.5" width="28" height="28" rx="14" fill="#008B07" />
      <path
        d="M11.0412 7.00001C11.8429 6.99844 12.6124 7.31563 13.1801 7.8815C13.748 8.44749 14.0676 9.21598 14.0686 10.0177C14.0697 10.8195 13.752 11.5888 13.1857 12.1562C12.6193 12.7236 11.8507 13.0428 11.0489 13.0433C10.2472 13.0438 9.47824 12.7256 8.91105 12.1589C8.34399 11.5921 8.02539 10.8234 8.02539 10.0216C8.02539 9.22118 8.34296 8.45349 8.90831 7.8871C9.47381 7.32057 10.2409 7.00157 11.0412 7.00001Z"
        fill="white"
      />
      <path
        d="M6.33415 19.3023C6.33571 18.0542 6.83218 16.8578 7.7146 15.9753C8.59716 15.0928 9.79361 14.5963 11.0416 14.5947C12.2902 14.5923 13.4878 15.0902 14.3666 15.9773C14.6748 16.2826 14.9381 16.6303 15.1482 17.0098C15.5387 17.7123 15.7398 18.5044 15.7316 19.3081V21.6939H6.33398L6.33415 19.3023ZM22.6673 21.688H17.219V19.3023C17.2177 19.0585 17.2022 18.815 17.1723 18.5731C17.1723 18.4973 17.1723 18.4214 17.1373 18.3456C17.1373 18.1824 17.0789 18.0189 17.0439 17.8557C17.0089 17.6924 17.003 17.6865 16.9739 17.599C16.9447 17.5115 16.8805 17.2956 16.8222 17.1498C16.7638 17.004 16.7638 16.9922 16.7347 16.9165L16.6996 16.829H16.6999C17.4478 16.2774 18.3742 16.0238 19.2988 16.1171C20.2234 16.2106 21.0803 16.6445 21.7029 17.3345C22.3254 18.0244 22.6691 18.9213 22.6673 19.8506L22.6673 21.688Z"
        fill="white"
      />
      <path
        d="M18.9159 10.4243C19.5038 10.4243 20.0675 10.6579 20.4832 11.0736C20.8989 11.4893 21.1325 12.0531 21.1325 12.641C21.1325 13.2289 20.8989 13.7928 20.4832 14.2084C20.0675 14.6241 19.5038 14.8576 18.9159 14.8576C18.328 14.8576 17.764 14.6241 17.3484 14.2084C16.9327 13.7927 16.6992 13.2288 16.6992 12.641C16.7007 12.0536 16.9348 11.4907 17.3501 11.0753C17.7655 10.66 18.3284 10.4259 18.9159 10.4243Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const LocationsIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "29", height: "28", fill: "none" }}
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
    >
      <rect x="0.75" width="28" height="28" rx="14" fill="#008B07" />
      <path
        d="M21.75 12.8335C21.75 8.95416 18.5417 5.8335 14.75 5.8335C10.8707 5.8335 7.75 8.95433 7.75 12.8335V13.1252C7.75 13.1543 7.86667 14.1752 7.98333 14.6127C8.8 18.0253 11.5707 20.621 14.75 23.042C17.9292 20.6212 20.7 18.0253 21.5167 14.6127C21.6333 14.1752 21.75 13.1835 21.75 13.1252V12.8335ZM14.75 15.7502C13.1458 15.7502 11.8333 14.4377 11.8333 12.8335C11.8333 11.2293 13.1458 9.91683 14.75 9.91683C16.3542 9.91683 17.6667 11.2293 17.6667 12.8335C17.6667 14.4377 16.3542 15.7502 14.75 15.7502Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const TotalRepresentedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "29", height: "28", fill: "none" }}
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
    >
      <rect x="0.5" width="28" height="28" rx="14" fill="#008B07" />
      <path
        d="M11.0412 7.00001C11.8429 6.99844 12.6124 7.31563 13.1801 7.8815C13.748 8.44749 14.0676 9.21598 14.0686 10.0177C14.0697 10.8195 13.752 11.5888 13.1857 12.1562C12.6193 12.7236 11.8507 13.0428 11.0489 13.0433C10.2472 13.0438 9.47824 12.7256 8.91105 12.1589C8.34399 11.5921 8.02539 10.8234 8.02539 10.0216C8.02539 9.22118 8.34296 8.45349 8.90831 7.8871C9.47381 7.32057 10.2409 7.00157 11.0412 7.00001Z"
        fill="white"
      />
      <path
        d="M6.33415 19.3023C6.33571 18.0542 6.83218 16.8578 7.7146 15.9753C8.59716 15.0928 9.79361 14.5963 11.0416 14.5947C12.2902 14.5923 13.4878 15.0902 14.3666 15.9773C14.6748 16.2826 14.9381 16.6303 15.1482 17.0098C15.5387 17.7123 15.7398 18.5044 15.7316 19.3081V21.6939H6.33398L6.33415 19.3023ZM22.6673 21.688H17.219V19.3023C17.2177 19.0585 17.2022 18.815 17.1723 18.5731C17.1723 18.4973 17.1723 18.4214 17.1373 18.3456C17.1373 18.1824 17.0789 18.0189 17.0439 17.8557C17.0089 17.6924 17.003 17.6865 16.9739 17.599C16.9447 17.5115 16.8805 17.2956 16.8222 17.1498C16.7638 17.004 16.7638 16.9922 16.7347 16.9165L16.6996 16.829H16.6999C17.4478 16.2774 18.3742 16.0238 19.2988 16.1171C20.2234 16.2106 21.0803 16.6445 21.7029 17.3345C22.3254 18.0244 22.6691 18.9213 22.6673 19.8506L22.6673 21.688Z"
        fill="white"
      />
      <path
        d="M18.9159 10.4243C19.5038 10.4243 20.0675 10.6579 20.4832 11.0736C20.8989 11.4893 21.1325 12.0531 21.1325 12.641C21.1325 13.2289 20.8989 13.7928 20.4832 14.2084C20.0675 14.6241 19.5038 14.8576 18.9159 14.8576C18.328 14.8576 17.764 14.6241 17.3484 14.2084C16.9327 13.7927 16.6992 13.2288 16.6992 12.641C16.7007 12.0536 16.9348 11.4907 17.3501 11.0753C17.7655 10.66 18.3284 10.4259 18.9159 10.4243Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const TotalCareerTransfersIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "29", height: "28", fill: "none" }}
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
    >
      <rect x="0.5" width="28" height="28" rx="14" fill="#008B07" />
      <path
        d="M18.2654 7.00139C18.158 7.01423 18.0773 7.10533 18.0776 7.21333V9.74435H12.6099C12.4931 9.74502 12.3987 9.8395 12.398 9.95628V12.881C12.3987 12.9978 12.4931 13.0923 12.6099 13.093H18.0776V15.624H18.0778C18.0799 15.7091 18.1326 15.7847 18.2117 15.8162C18.2906 15.8478 18.3809 15.8294 18.4412 15.7693L22.6072 11.5669C22.6874 11.4844 22.6874 11.353 22.6072 11.2703L18.4412 7.06205C18.395 7.0161 18.3302 6.99379 18.2655 7.0015L18.2654 7.00139ZM10.6904 11.7549C10.6423 11.7601 10.5974 11.7814 10.5631 11.8155L6.3971 16.0178C6.35669 16.0578 6.33398 16.1123 6.33398 16.1692C6.33398 16.226 6.35669 16.2806 6.3971 16.3206L10.5631 20.5229C10.6242 20.5836 10.7158 20.6014 10.7953 20.5683C10.8747 20.5352 10.9264 20.4576 10.9264 20.3715V17.8464H16.3945C16.5113 17.8459 16.6057 17.7513 16.6064 17.6345V14.7099C16.6078 14.6527 16.586 14.5974 16.5461 14.5565C16.5063 14.5155 16.4516 14.4921 16.3945 14.4919H10.9264V11.9668V11.9669C10.9264 11.9063 10.9007 11.8486 10.8557 11.8082C10.8107 11.7678 10.7506 11.7485 10.6904 11.755V11.7549Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const YesIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <rect width="20" height="20" rx="10" fill="#C9FFC4" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2464 6.15838L8.27969 11.9167L6.69635 10.2251C6.40469 9.95005 5.94635 9.93338 5.61302 10.1667C5.28802 10.4084 5.19635 10.8334 5.39635 11.1751L7.27135 14.2251C7.45469 14.5084 7.77135 14.6834 8.12969 14.6834C8.47135 14.6834 8.79635 14.5084 8.97969 14.2251C9.27969 13.8334 15.0047 7.00838 15.0047 7.00838C15.7547 6.24172 14.8464 5.56672 14.2464 6.15005V6.15838Z"
        fill="#008B07"
      />
    </SvgIcon>
  );
};

export const NoIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <rect width="20" height="20" rx="10" fill="#FFEDED" />
      <path d="M14 6L6 14M14 14L6 6" stroke="#FF4D4E" strokeWidth="1.5" strokeLinecap="round" />
    </SvgIcon>
  );
};
